export default __webpack_public_path__ + "static/media/DrawDohwaji.3846dbe7.svg";